import { EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { isObservable, lastValueFrom } from 'rxjs';

export function sequentialGuards(...guards: CanActivateFn[]): CanActivateFn {
  return async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    // 1. Capture the injector while we are still in a valid synchronous context
    const injector = inject(EnvironmentInjector);

    for (const guard of guards) {
      // 2. Wrap the guard execution in the captured context
      const result = runInInjectionContext(injector, () => guard(route, state));

      // 3. Resolve the result (Observable, Promise, or boolean)
      const resolvedResult = isObservable(result)
        ? await lastValueFrom(result)
        : await result;

      if (resolvedResult !== true) {
        return resolvedResult;
      }
    }

    return true;
  };
}
